const STYLE_IMPORTERS = [
  () => import("./assests/frontend/assets/css/custom.css"),
  () => import("./assests/new/frontend/css/custom2.css"),
  () => import("./assests/admin/css/checkout-funnel.css"),
];

let stylesLoaded = false;

const runStyleImporters = () => {
  if (stylesLoaded) return;
  stylesLoaded = true;
  STYLE_IMPORTERS.forEach((load) => load().catch(() => {}));
};

export const lazyLoadGlobalStyles = () => {
  if (typeof window === "undefined") {
    return;
  }
  if (window.__lazyGlobalStylesLoaded) {
    return;
  }
  window.__lazyGlobalStylesLoaded = true;

  if (typeof requestIdleCallback === "function") {
    requestIdleCallback(runStyleImporters);
  } else {
    setTimeout(runStyleImporters, 1000);
  }
};
